import { Link } from 'react-router-dom';
import { articles, featuredArticles } from '@/mocks/site';

export default function FeaturedContent() {
  const featured = articles.filter((a) => featuredArticles.includes(a.id));

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑精选，不容错过的精彩内容
            </p>
          </div>
          <Link
            to="/article/1"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-100 transition-colors"
            >
              <div className="sm:w-48 flex-shrink-0 aspect-video sm:aspect-[4/3] rounded-md overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium w-fit mb-2">
                  {article.categoryName}
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {article.summary}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}